// extracted by mini-css-extract-plugin
export default {"container":"Tca-z","oos":"Uca-z","oosUx":"Vca-z","selected":"Wca-z","labelOos":"Xca-z"};